module.exports = __webpack_public_path__ + "static/hero_image-cropped-110cc43d72b3b9a131e7636c81ac4b86.png";